export const FloodMapCodes = [
  {
    label: 'Report Date',
    code: 'FM_REPORT_DATE',
  },
  {
    label: 'County qa2',
    code: 'FM_COUNTY_NAME'
  },
  {
    label: 'Flood Zone Code',
    code: 'FM_FLOOD_ZONE_CODE'
  },
  {
    label: 'Community Name',
    code: 'FM_COMMUNITY_NAME'
  },
  {
    label: 'Community Number - Map Panel & Suffix',
    code: 'FM_PANEL_NUMBER'
  },
  {
    label: 'Panel Date',
    code: 'FM_PANEL_DATE'
  },
  {
    label: 'Special Flood Hazard Area (SFHA)',
    code: 'FM_SFHA'
  },
  {
    label: 'Distance to 100 yr Flood Plain',
    code: 'DIST_FLOOD_PLAIN_100_YEARS'
  },
  {
    label: 'Flood Code Description',
    code: 'FM_FLOOD_ZONE_CODE_DESC'
  },
  {
    label: 'Community Participation Status',
    code: 'FN_CPS'
  },
  {
    label: 'Original Panel Firm Date',
    code: 'FN_ORIGINAL_PANEL_FIRM_DATE'
  },
  {
    label: 'FIPS Code',
    code: 'FN_FIPS_CODE'
  },
  {
    label: 'Coastal Barrier Resource Area (CBRA)',
    code: 'FN_CRBA'
  },
  {
    label: 'Letter of Map Amendment (LOMA)',
    code: 'LOMA'
  },
  {
    label: 'Distance to 500 yr Flood Plain',
    code: 'DIST_FLOOD_PLAIN_500_YEARS'
  },
  {
    label: 'Distance to Dam',
    code: 'DIST_TO_DAM'
  },
  {
    label: '100 yr Plain Note',
    code: 'PLAIN_NOTE_100_YEAR'
  },
  {
    label: '500 yr Plain Note',
    code: 'PLAIN_NOTE_500_YEAR'
  },
  {
    label: 'Distance to Levee',
    code: 'DIST_TO_LEVEE'
  },
  {
    label: 'Sub-watershed Name',
    code: 'SUBWATERSHED_NAME'
  },
  {
    label: 'Sub-watershed Code',
    code: 'SUBWATERSHED_CODE'
  },
  {
    label: 'Additional Impact Areas',
    code: 'ADDITIONAL_IMPACT_AREA'
  },
  {
    label: 'Property Elevation',
    code: 'PROPERTY_ELEVATION'
  },
  {
    label: 'Water Surface Elevation',
    code: 'WATER_SURFACE_ELEVATION'
  },
  {
    label: 'Elevation Variance',
    code: 'ELEVATION_VARIANCE'
  },
  {
    label: 'Additional Comments',
    code: 'ADDITIONAL_COMMENTS'
  },
  {
    label: 'Flood Risk Rating',
    code: 'FLOOD_RISK_RATING'
  },
  {
    label: 'Flood Risk Score',
    code: 'FLOOD_RISK_SCORE'
  },
  {
    label: 'Flash Flood Rating',
    code: 'FLASH_FLOOD_RATING'
  },
  {
    label: 'Flash Flood Score',
    code: 'FLASH_FLOOD_SCORE'
  },
  {
    label: 'Coastal Barrier Date',
    code: 'COASTAL_BARRIER_DATE'
  },
  {
    label: 'Coastal Barrier Resource Area (CBRA)',
    code: 'COASTAL_BARRIER_RESOURCE_AREA'
  },
  {
    label: 'Letter of Map Amendment (LOMA)',
    code: 'LOMA'
  },
];
// FloodMapConstants
